<template>
  <section class="curation-timeline">
    <h2
      v-if="!isEmpty(def.title)"
      class="jps-curation-timeline-title is-size-5-desktop is-size-6-touch has-text-weight-bold generated-5"
    >
      {{ ls(def.title) }}
    </h2>
    <TimelineView
      :def="def"
      :selected="selectedIndex"
      @click-time="selectTime($event)"
    />
    <div class="timeline-points" v-if="selectedTime">
      <div class="timeline-points-title">
        {{ ls(selectedTime.time.name) }}
      </div>
      <div class="timeline-points-description">
        {{ ls(selectedTime.description) }}
      </div>
      <CurationPartsRenderer
        :curation="curation"
        :parts="selectedTime.parts"
      />
    </div>
  </section>
</template>

<script lang="ts" setup>
const { ls } = useI18n()

interface Props {
  curation: Curation,
  def: PartTimeline,
}
const props = withDefaults(defineProps<Props>(), {})

const selectedIndex: Ref<number> = ref(0)

const selectTime = index => {
  if (selectedIndex.value === index) {
    selectedIndex.value = -1
  } else {
    selectedIndex.value = index
  }
}

const selectedTime = computed(() => {
  if (props.def.parts && props.def.parts.length > 0)
    return props.def.parts[selectedIndex.value]
  return null
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.curation-timeline {
  padding: 1.5rem 0;
  position: relative;
  .curation-timeline-title {
    font-size: 1.25rem;
    margin-bottom: 1rem;
  }
  .timeline-points {
    background: #f2f2f2;
    padding-top: 1rem;
    .timeline-points-title {
      font-size: 1.25rem;
      @include base-content-width();
      padding-bottom: 0.5rem;
    }
    .timeline-points-description {
      @include base-content-width();
      padding-bottom: 1.5rem;
      @include is-mobile() {
        font-size: 0.8125rem;
      }
    }
    margin-top: 1rem;

    /* .timeline-points-description {
       font-weight: bold;
       max-width: lcuration-content-width;
       margin: 0 auto;
    } */
  }
}

.generated-5 {
    text-align: center;
}
</style>
